import { errorToast } from "@design-system/components/toast";
import { onSuccessLogin } from "@framework/auth/events";
import { useTrustedDeviceLogin } from "@framework/auth/hooks/use-trusted-device-login.hook";
import { useAction } from "@framework/shared/hooks";
import { trans } from "@mongez/localization";
import { startAuthentication } from "@simplewebauthn/browser";
import { useState } from "react";

/**
 * Authenticate with a discoverable passkey and the normal application session.
 */
export function usePasskeyLogin() {
  const [loading, setLoading] = useState(false);
  const getOptions = useAction("/auth/login/passkey/options");
  const verify = useAction("/auth/login/passkey/verify");
  const trustedDeviceLogin = useTrustedDeviceLogin();

  const login = async () => {
    setLoading(true);

    try {
      const optionsResult = await getOptions({});

      if (optionsResult.error) {
        return errorToast(optionsResult.error);
      }

      const assertion = await startAuthentication({
        optionsJSON: optionsResult.data.options,
      });
      const result = await verify({
        ceremonyToken: optionsResult.data.ceremonyToken,
        response: assertion,
        ...(await trustedDeviceLogin.prepareLoginDevice()),
      });

      if (result.error) {
        return errorToast(result.error);
      }

      onSuccessLogin(result.data.user);
    } catch (error) {
      errorToast(
        error instanceof Error
          ? error.message
          : trans("auth.passkeyLoginFailed"),
      );
    } finally {
      setLoading(false);
    }
  };

  return { loading, login };
}
